import assert from 'owa-assert/lib/assert';
import type { IdentityInfo } from 'owa-auth-types';

type FallbackFunction = () => IdentityInfo;

let fallbackIdentityInfoFunction: FallbackFunction | undefined = undefined;

export function setFallbackIdentityInfoFunction(fallback: FallbackFunction): void {
    fallbackIdentityInfoFunction = fallback;
}

export function callFallbackIdentityInfoFunction(): IdentityInfo {
    assert(
        !!fallbackIdentityInfoFunction,
        'Call setFallbackIdentityInfoFunction to set the function'
    );
    return fallbackIdentityInfoFunction();
}
